import React, { FC } from 'react';
import { Container, Grid } from '@material-ui/core';
import Image from 'blog/components/Image';

interface ProjectsImageProps {
  image1: string;
  image2: string;
  image3: string;
  position?: string;
}

const ProjectsImageSection: FC<ProjectsImageProps> = ({ image1, image2, image3 }) => {
  return (
    <Container fixed>
      <Grid container spacing={4}>
        <Grid item md={6} xs={12}>
          <Image src={image1} alt={image1} width={570} height={224} layout="responsive" data-aos="fade-up" />
        </Grid>
        <Grid item md={6} xs={12}>
          <Image src={image2} alt={image2} width={570} height={224} layout="responsive" data-aos="fade-up" data-aos-delay="300" />
        </Grid>
        <Grid item xs={12}>
          <Image src={image3} alt={image3} width={570} height={224} layout="responsive" data-aos="fade-up" />
        </Grid>
      </Grid>
    </Container>
  );
};
export default ProjectsImageSection;
